import { useGlobalSearchParams } from "expo-router";

import { useGlobalStore } from "~/stores/global";

export function useCurrentAccount() {
  const { store } = useGlobalStore(true);
  const params = useGlobalSearchParams<{ account: string }>();
  const account = store.accountBySlug(params.account!);
  if (!account) {
    throw new Error(`Account ${params.account} not found`);
  }
  return account;
}
